import { RsAmplitudeService } from '../services/amplitude.service';
import { EnvironmentProviders, inject, provideAppInitializer, Type } from '@angular/core';

/**
 * Eagerly creates and initializes the given Amplitude service at application
 * bootstrap, so tracking (incl. the first page view) starts immediately.
 */
export function provideRsAmplitude(serviceClass: Type<RsAmplitudeService<string>>): EnvironmentProviders {
  return provideAppInitializer(() => {
    try {
      inject(serviceClass).initialize();
    } catch (error) {
      console.error('[RsAmplitude] initialization failed; continuing without analytics', error);
    }
  });
}
